import { SignOutIcon, XIcon } from '@phosphor-icons/react';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setRPack } from '../../../../../../apps/frontend/src/redux/slices/packSlice';
import { setUser } from '../../../../../../apps/frontend/src/redux/slices/userSlice';
import ModalCloseButton from '../../generic/ModalCloseButton';

const LogoutModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const confirmLogout = () => {
    dispatch(setRPack(null));
    dispatch(setUser(null));
    localStorage.clear();
    sessionStorage.clear();
    Cookies.remove('token');

    if (window?.webengage?.user) {
      window.webengage.user.logout();
    }

    navigate('/auth/login');
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      style={{
        background: 'rgba(16, 24, 40, 0.70)',
        backdropFilter: 'blur(6px)',
      }}
    >
      <div className="relative bg-[var(--q3-surface-default)] rounded-lg p-6 w-full max-w-md">
        <ModalCloseButton onClick={onClose} />

        <div className="flex justify-center mb-4">
          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-[var(--q3-danger-light)]">
            <SignOutIcon size={24} className="text-[var(--q3-danger-normal)]" />
          </div>
        </div>

        <div className="flex justify-center mb-4">
          <h3 className="text-lg font-semibold text-[var(--q3-neutral-default)]">Are you sure you want to log out?</h3>
        </div>

        <div className="flex flex-col gap-3 mt-6">
          <button
            onClick={confirmLogout}
            className="w-full px-4 py-2 rounded-full bg-[var(--q3-danger-normal)] text-[var(--q3-neutral-default_inverted)] hover:opacity-90 transition-opacity cursor-pointer"
          >
            Log Out
          </button>
          <button
            onClick={onClose}
            className="w-full px-4 py-2 rounded-full border border-[var(--q3-stroke-normal)] bg-[var(--q3-surface-default)] text-[var(--q3-neutral-default)] hover:bg-[var(--q3-surface-dimmer)] transition-colors cursor-pointer"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
